import {hashCode} from '@src/helpers/hash/hashCode';

export function shortCode(value: any): string {
    return hashCode(String(value));
}
